import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import RenewalAreTheNewArr from '../components/RenewalsAreTheNewArr'
import { Helmet } from 'react-helmet-async'

export default function RenewalsAreTheArr4SmartWaystoBuildDriveGrowthWithRenewalIntelligence() {
  return (
    <div>
      <Helmet>
        <title>Renewal Intelligence to Drive ARR Growth | ProPlus Data</title>
        <meta name="description" content="Discover how ProPlus Data's Renewal Intelligence helps you drive growth with smarter renewals, customer retention, and revenue expansion strategies."/>
        <meta name="keywords" content="Renewals, ARR, Growth, Renewal Intelligence, Customer Retention, Revenue Expansion, ProPlus Data, Subscription Growth, Customer Success, Renewal Strategy"/>
        <link rel="canonical" href="https://proplusdata.co/renewals-are-the-new-arr-4-smart-ways-to-build-drive-growth-with-renewal-intelligence"/>
        <meta property="og:url" content="https://proplusdata.co/renewals-are-the-new-arr-4-smart-ways-to-build-drive-growth-with-renewal-intelligence" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Renewal Intelligence to Drive ARR Growth | ProPlus Data" />
        <meta property="og:description" content="Discover how ProPlus Data's Renewal Intelligence helps you drive growth with smarter renewals, customer retention, and revenue expansion strategies." />
      </Helmet> 
      <Header1/>
      <RenewalAreTheNewArr/>
      <Footer/>
    </div>
  )
}
